<template>
	<div>
		<b-container>
			<b-breadcrumb :items="breadcrumb" style="margin-top: 15px;"></b-breadcrumb>
			<b-row style="margin: 10px 0px 10px 0px; padding: 0px;">
				<b-col cols="3" style="padding-left:0px;">
					<b-button variant="primary" block class="title" @click="newPurchaseOrder"> {{$lang.finnance.purchaseOrders.new}}</b-button>
				</b-col>
				<b-col cols="9" style="padding-right: 0px;" >
					<b-input-group >
						<b-input :placeholder="$lang.common.search" v-model="keyword" />
						<b-input-group-append>
							<b-button variant="outline-primary" @click="searchPurchaseOrders" :disabled="keyword.length == 0">{{ $lang.common.search }}</b-button>
						</b-input-group-append>
					</b-input-group>
				</b-col>
			</b-row>
			<b-table striped hover outlined :items="$store.getters.purchaseOrders" :fields="fields" @row-clicked="editPurchaseOrder" style="cursor:pointer">
				<template v-slot:cell(index)="data">
					{{ data.index + 1 }}
				</template>
				<template v-slot:cell(orderNumber)="data">
					{{ addPad(data.item.orderNumber) }}
				</template>
				<template v-slot:cell(status)="data">
					{{ $lang.finnance.purchaseOrders.statuses[data.item.status.value] }}
				</template>
				<template v-slot:cell(provider)="data">
					{{ data.item.provider.name }}
				</template>
				<template v-slot:cell(costCenter)="data">
					{{ data.item.costCenter.name }}
				</template>
			</b-table>
			<b-button variant="primary" class="title" block value="Save" v-on:click="loadMore" v-if="$store.state.purchaseOrders.purchaseOrdersPagination.showLoadMore == true">{{$lang.buttons.loadMore}}</b-button>
		</b-container>
	</div>
</template>

<script>

export default {
	data() {
		return {
			fields: [
				{key: 'index', label: '#'},
				{key: 'orderNumber', label: 'Orden de compra'},
				{key: 'costCenter', label: 'Centro de costo'},
				{key: 'provider', label: 'Proveedor'},
				{key: 'status', label: 'Estado'}
			],
			keyword: '',
			breadcrumb: [{'text': this.$lang.modules.finnance,'href': '/'},{'text': this.$lang.finnance.purchaseOrders.title,'href': '#'}],
			autoRefresh: ''
		}
	},

	methods: {
		newPurchaseOrder() {
			this.$router.push({ name: 'PurchaseOrdersNew' })
		},
		editPurchaseOrder(purchaseOrder) {
			console.log(purchaseOrder)
			this.$router.push({ name: 'PurchaseOrdersEdit', params: { purchaseOrderId: purchaseOrder.objectID } })
		},
		addPad(str) {
			if (str == undefined) {
				return 'TBD'
			}
			return str.toString().padStart(4,'0')
		},
		loadMore() {
			let currentPagination = this.$store.getters.purchaseOrdersPagination;
			this.$store.dispatch('updatePurchaseOrdersPagination', {autoRefresh: false,page: currentPagination.page++, ...currentPagination});
			this.$store.dispatch('fetchPurchaseOrders')
		},
		loadPurchaseOrders() {
			this.$store.dispatch('fetchPurchaseOrders')
		},
		searchPurchaseOrders() {
			console.log(this.keyword)
			this.$store.commit('setFilters', {keyword: this.keyword})
			this.$store.dispatch('fetchPurchaseOrders')
		}
	},
	created() {
		this.$Progress.start()
		this.$store.commit('setDefaultPurchaseOrdersPagination')
		this.$store.commit('setPurchaseOrders', [])

		this.loadPurchaseOrders()
		this.$Progress.finish()
	},
}
</script>

<style>

</style>